;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter';
import { Dictionaries } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  toggle: () => void;
  isOpen: boolean;
};
const JobmatchInfoModal = ({ toggle, isOpen, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} className="px-0 mx-3">
        {capitalizeFirstLetter(formatMessage({ id: 'info' }))}
      </ModalHeader>
      <ModalBody>
        <p>{formatMessage({ id: 'no_jobmatches_paragraph_1' })}</p>
        <p>{formatMessage({ id: 'no_jobmatches_paragraph_2' })}</p>
      </ModalBody>
    </Modal>
  );
};

export default JobmatchInfoModal;
